import type { IContextQueryResult } from '@modules/core/services/query/types';
import { AFFILIATE_PROGRAM_CREATIVES_PERMISSIONS } from '@modules/affiliate-program-creatives/constants';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';

import type {
  IAffiliateProgramCreativeCompany,
  IAffiliateProgramDefaultCreativeResponse,
} from '../types';
import {
  AFFILIATE_PROGRAM_CREATIVES_DEFAULT_COMPANY_QUERY_KEY,
  AFFILIATE_PROGRAM_CREATIVES_DEFAULT_COMPANY_URL,
} from '../constants';

export default function useAffiliateProgramCreativeDefaultCompany(): IContextQueryResult<
  IAffiliateProgramDefaultCreativeResponse,
  Error,
  IAffiliateProgramCreativeCompany
> {
  const { fetchGet } = useRestClient();

  return useContextQuery<
    IAffiliateProgramDefaultCreativeResponse,
    Error,
    IAffiliateProgramCreativeCompany
  >({
    queryKey: [AFFILIATE_PROGRAM_CREATIVES_DEFAULT_COMPANY_QUERY_KEY],
    queryFn: ({ signal }) => fetchGet<IAffiliateProgramDefaultCreativeResponse>(
      AFFILIATE_PROGRAM_CREATIVES_DEFAULT_COMPANY_URL,
      {
        signal,
        permission: AFFILIATE_PROGRAM_CREATIVES_PERMISSIONS.SHOW,
      },
    ),
    select: (data) => data.default_advertising_company,
  });
}
